<template>
	<div>
		<AppInput :id="inputId" v-bind="$attrs" />
	</div>
</template>

<script setup>
import 'vue3-google-map';
import { getCurrentInstance, onMounted, computed } from 'vue';

const emit = defineEmits(['selectPlace']);

const id = getCurrentInstance()?.uid;

const inputId = computed(() => `autocomplete-${id}`);

onMounted(async () => {
	const input = document.querySelector(`input#${inputId.value}`);
	const options = {
		fields: ['address_components', 'geometry', 'icon', 'name'],
		types: ['geocode', 'establishment'],
		strictBounds: false,
	};

	const places = await window.google.maps.importLibrary('places');

	setTimeout(() => {
		const autocomplete = new places.Autocomplete(input, options);

		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();

			if (!place.geometry) return;

			emit('selectPlace', place);
		});
	}, 2000);
});
</script>

<style>
.pac-container {
	z-index: 2000;
}
</style>
